import { PathOptions } from "leaflet";

export const eol_base_existente = (feature: any): PathOptions => {
  return {
    color: "#1E90FF",
    weight: 2,
    opacity: 1,
    fillColor: "#4169E1",
    fillOpacity: 0.6,
  };
};
